import { Box, HStack, VStack, Text, Icon } from '@chakra-ui/react';
import { FiArrowDown, FiCornerDownLeft } from 'react-icons/fi'
import type { ScriptLane } from '../../types/script'
import { getStepNumber } from './laneUtils'

interface RejoinIndicatorProps {
  branches: ScriptLane[]
  lanes: ScriptLane[]
}

export function RejoinIndicator({ branches, lanes }: RejoinIndicatorProps) {
  // Check if all branches merge to the same target
  const mergeTargets = branches
    .map((b) => b.mergeTargetClientId)
    .filter((t) => t !== undefined)

  // Only show indicator if ALL branches rejoin at the same point
  const allMergeToSameTarget =
    mergeTargets.length === branches.length &&
    mergeTargets.length > 0 &&
    mergeTargets.every((t) => t === mergeTargets[0])

  if (!allMergeToSameTarget) {
    // Don't show anything - each branch shows its own rejoin status
    return null
  }

  const commonMergeTarget = mergeTargets[0]
  const mergeStepNumber = getStepNumber(lanes, commonMergeTarget)

  // All branches merge to the same target
  return (
    <VStack gap={2} py={4}>
      <HStack gap={3} justify="center">
        {branches.map((branch) => (
          <HStack key={branch.id} gap={0}>
            <Box
              w="2px"
              h="30px"
              bg={`${branch.colorScheme}.400`}
              borderRadius="full"
            />
            <Icon
              boxSize={4}
              color={`${branch.colorScheme}.500`}
              transform="translateY(8px)"
              asChild><FiArrowDown /></Icon>
          </HStack>
        ))}
      </HStack>
      <HStack gap={2}>
        <Icon boxSize={4} color="info.fg" asChild><FiCornerDownLeft /></Icon>
        <Text fontSize="sm" fontWeight="medium" color="info.fg">
          All paths rejoin at Step {mergeStepNumber}
        </Text>
        <Icon boxSize={4} color="info.fg" asChild><FiArrowDown /></Icon>
      </HStack>
    </VStack>
  );
}
